import { render, staticRenderFns } from "./MySharedFolders.vue?vue&type=template&id=3839b65a&scoped=true&"
import script from "./MySharedFolders.vue?vue&type=script&lang=js&"
export * from "./MySharedFolders.vue?vue&type=script&lang=js&"
import style0 from "./MySharedFolders.vue?vue&type=style&index=0&id=3839b65a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839b65a",
  null
  
)

export default component.exports